import type { RegisteredServices } from '@/core/container/types'
import type { TmWrappers } from '@/wrappers'

export const templatesSmsTable = 'templatesSmsTable' as RegisteredServices
export const templatesSmsByCategoryTable = 'templatesSmsByCategoryTable' as RegisteredServices
export const templatesShareTable = 'templatesShareTable' as RegisteredServices
export const templatesSelectTable = 'templatesSelectTable' as RegisteredServices
export const templateShareModalId: TmWrappers = 'templateShare'

export const emailTemplatesTable = 'emailTemplatesTable' as RegisteredServices
export const emailTemplatesByCategoryTable = 'emailTemplatesByCategoryTable' as RegisteredServices
